news = {};

news.grid = {
    currentPage: 1,
    totalPages: 1,
    isLoading: false,
    
    init: function () {
        news.grid.setupLoadMore();
       news.grid.animateInitialItems();
    },
    
    setupLoadMore: function () {
        let $newsGrid = $('.js-newsGrid');
        
        // Calcular el total de páginas basado en los items actuales
        let totalItems = $newsGrid.find('.fancy-item').length;
        let itemsPerPage = news.grid.getItemsPerPage();
        news.grid.totalPages = Math.ceil(totalItems / itemsPerPage);
        
        // Ocultar items que no pertenecen a la primera página
        news.grid.hideExtraItems();
        
        // Configurar botón de cargar más
        news.grid.setupLoadMoreButton();
        
        // Actualizar contador
        news.grid.updateCounter();
    },
    
    getItemsPerPage: function () {
        let itemsPerPage;
        if ($(window).width() > 940) {
            itemsPerPage = 12; // 3 columnas x 4 filas
        } else if ($(window).width() > 768) {
            itemsPerPage = 12; // 2 columnas x 6 filas
        } else {
            itemsPerPage = 10; // 1 columna x 10 filas
        }
        return itemsPerPage;
    },
    
    hideExtraItems: function () {
        let $newsGrid = $('.js-newsGrid');
        let itemsPerPage = news.grid.getItemsPerPage();
        
        $newsGrid.find('.fancy-item').each(function (index) {
            if (index >= itemsPerPage) {
                $(this).hide().addClass('hidden-item');
            } else {
                $(this).show().removeClass('hidden-item');
            }
        });
    },
    
    setupLoadMoreButton: function () {
        let $button = $('.js-loadMore');
        
        // Mostrar u ocultar el botón según si hay más páginas
        if (news.grid.totalPages > 1) {
            $button.removeClass('is-hidden');
        } else {
            $button.addClass('is-hidden');
        }
        
        // Bind del evento click
        $button.off('click').on('click', function (e) {
            e.preventDefault();
            news.grid.loadMore();
        });
    },
    
    loadMore: function () {
        if (news.grid.isLoading) return;
        
        news.grid.isLoading = true;
        let $button = $('.js-loadMore');
        $button.addClass('is-loading').prop('disabled', true);
        
        // Simular delay de carga (puedes ajustar o eliminar)
        setTimeout(function () {
            news.grid.showNextPage();
            news.grid.isLoading = false;
            
            if (news.grid.currentPage >= news.grid.totalPages) {
                $button.addClass('is-hidden');
            } else {
                $button.removeClass('is-loading').prop('disabled', false);
            }
        }, 300);
    },
    
    showNextPage: function () {
        news.grid.currentPage++;
        
        let $newsGrid = $('.js-newsGrid');
        let itemsPerPage = news.grid.getItemsPerPage();
        let startIndex = (news.grid.currentPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;
        
        // Mostrar items de la siguiente página
        $newsGrid.find('.fancy-item').each(function (index) {
            if (index >= startIndex && index < endIndex) {
                $(this).slideDown(400).removeClass('hidden-item');
            }
        });
        
        // Actualizar contador
        news.grid.updateCounter();
    },
    
    updateCounter: function () {
        let $newsGrid = $('.js-newsGrid');
        let totalItems = $newsGrid.find('.fancy-item').length;
        let visibleItems = $newsGrid.find('.fancy-item:visible').length;
        
        $('.count').html(visibleItems + ' de ' + totalItems);
        
        // Ocultar botón si ya no hay más items
        if (visibleItems >= totalItems) {
            $('.js-loadMore').addClass('is-hidden');
        }
    },
    
    animateInitialItems: function () {
        // Animar items iniciales
    }
};

// Recalcular al cambiar tamaño de ventana
$(window).on('resize', function () {
    if (news.grid.currentPage === 1) {
        news.grid.hideExtraItems();
        news.grid.updateCounter();
    }
});

news.init = function () {
    news.grid.init();
};

news.binds = function () {
    //news.binds();
};

$(document).ready(function () {
    news.binds();
    news.init();
});